/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { getRequiredAttributes, getRequiredSources } from '../../../adapters/policy'
import { shouldSpread } from '../../../utils'

import StepList from '../../../components/common/StepList'
import {
  DownloadYotiStep, CreateYotiStep, PhotoStep, IdDocumentStep, EmailStep, ShareStep
} from './steps'

import './InstructionsSection.scss'

const InstructionsSection = ({
  device,
  qrCodeDisplayed,
  policyAttributes
}) => {
  const requiredAttributes = getRequiredAttributes(policyAttributes)
  const requiredSources = getRequiredSources(policyAttributes)

  const steps = [
    <DownloadYotiStep device={device} />,
    <CreateYotiStep />,
    ...shouldSpread(PhotoStep.isShown(requiredAttributes), <PhotoStep />),
    ...shouldSpread(IdDocumentStep.isShown(requiredAttributes), <IdDocumentStep requiredAttributes={requiredAttributes} requiredSources={requiredSources} />),
    ...shouldSpread(EmailStep.isShown(requiredAttributes), <EmailStep />),
    <ShareStep qrCodeDisplayed={qrCodeDisplayed} />
  ]

  return (
    <div className="instructions-section">
      <StepList>
        {
          steps.map(
            (step, stepKey) => (
              <StepList.Item key={stepKey}>
                { step }
              </StepList.Item>
            )
          )
        }
      </StepList>
    </div>
  )
}

InstructionsSection.propTypes = {
  device: PropTypes.objectOf(PropTypes.any).isRequired,
  qrCodeDisplayed: PropTypes.bool.isRequired,
  policyAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      sourceConstraints: PropTypes.arrayOf(
        PropTypes.shape({
          softPreference: PropTypes.bool.isRequired,
          sources: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              subType: PropTypes.string.isRequired
            })
          ).isRequired
        }).isRequired
      )
    }).isRequired
  ).isRequired
}

export default InstructionsSection
